import { AxiosAuth, createScopedAxiosAuth } from "../../core/axios";
import { apiConfig } from "../../config/apiConfig";
import { apiUrls } from "../../utils/apiUrls";

const buildP2NewsByCountryUrl = (
  countryId: number,
  startDate?: string,
  endDate?: string,
  filter?: string
) => {
  const params = new URLSearchParams({ countryId: countryId.toString() });

  if (startDate) {
    params.append("startDate", startDate);
  }

  if (endDate) {
    params.append("endDate", endDate);
  }

  if (filter) {
    params.append("filter", filter);
  }

  return `${apiUrls.p2NewsCountryMap.getNewsByCountry}?${params.toString()}`;
};

const AnalyzerAxiosAuth = apiConfig.analyzerBaseUrl
  ? createScopedAxiosAuth(apiConfig.analyzerBaseUrl)
  : null;

type SaveP2NewsMappingPayload = {
  countryId: number;
  newsId: number;
  isPillarTwoNews: boolean;
};

const parseApiError = (error: any) => JSON.parse(error.message);

const getMissingAnalyzerConfigResponse = () => ({
  status: 500,
  data: {
    succeeded: false,
    message: "Analyzer API base URL is not configured",
  },
});

export const getLiveNewsByCountry = async (
  countryId: number,
  startDate?: string,
  endDate?: string,
  filter?: string
) => {
  try {
    return await AxiosAuth.get(
      buildP2NewsByCountryUrl(countryId, startDate, endDate, filter)
    );
  } catch (error: any) {
    return parseApiError(error);
  }
};

export const getAnalyzerNewsByCountry = async (
  countryId: number,
  startDate?: string,
  endDate?: string,
  filter?: string
) => {
  if (!AnalyzerAxiosAuth) {
    return getMissingAnalyzerConfigResponse();
  }

  try {
    return await AnalyzerAxiosAuth.get(
      buildP2NewsByCountryUrl(countryId, startDate, endDate, filter)
    );
  } catch (error: any) {
    return parseApiError(error);
  }
};

export const saveLiveP2NewsMapping = async (
  payload: SaveP2NewsMappingPayload
) => {
  try {
    return await AxiosAuth.post(apiUrls.p2NewsCountryMap.saveMapping, payload);
  } catch (error: any) {
    return parseApiError(error);
  }
};

export const saveAnalyzerP2NewsMapping = async (
  payload: SaveP2NewsMappingPayload
) => {
  if (!AnalyzerAxiosAuth) {
    return getMissingAnalyzerConfigResponse();
  }

  try {
    return await AnalyzerAxiosAuth.post(apiUrls.p2NewsCountryMap.saveMapping, payload);
  } catch (error: any) {
    return parseApiError(error);
  }
};
